import React, { useEffect, useState } from "react";
import "./TopBar.css";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";
import { NavLink } from "react-router-dom";
import algo from "algosdk"
import MyAlgoConnect from "@randlabs/myalgo-connect";
// const algosdk = require('algosdk');
const myAlgoWallet = new MyAlgoConnect();


function TopBar() {
  const [WalletAddress, setWalletAddress] = useState([]);
  // const [userAccount, setuserAccount] = useState("");
  async function connectAlgoWallet() {
    console.log("connect wallet");
    try {
      const accounts = await myAlgoWallet.connect();
      console.log("accounts", accounts);
      // const addresses = accounts.map(account => account.address);
      setWalletAddress(accounts[0].address)
      console.log("address1:", accounts.toString());
      console.log(accounts[0].address);
      localStorage.WalletAddress = accounts[0].address;


      // setTimeout(window.location.reload(), 2000);
      // console.log("address2:", AccountB);
      // console.log("address3:", AccountC);

    } catch (err) {
      console.error(err);
    }
  }

  const WalletListner = () => {
    if (localStorage.WalletAddress) {
      console.log(localStorage.WalletAddress, "local");
      setWalletAddress(localStorage.WalletAddress)
    }
  }
  const disconnectAlgoWallet = () => {
    console.log(localStorage.WalletAddress);
    localStorage.WalletAddress = "";
    window.location.reload()
  }

  const showDropdown = () => {
    document.getElementById("connectwalletbtn").classList.toggle("active")
  }

  useEffect(() => {
    WalletListner()
  }, []);


  return (
    <div>
      <section className="top-bar">
        <nav className="navbar navbar-expand-lg ">
          <div className="container-fluid">
            <Link className="navbar-brand" to="/">
              <img
                src="\assets\images\keeperlogo.png"
                alt=""
                className="img-fluid"
              />
            </Link>
            <button
              className="navbar-toggler collapsed d-flex d-lg-none  flex-column justify-content-around"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="toggler-icon top-bar"></span>
              <span className="toggler-icon middle-bar"></span>
              <span className="toggler-icon bottom-bar"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              <ul className="navbar-nav mx-auto mb-2 mb-lg-0  w-75">
                <li className="nav-item">
                  <NavLink className="nav-link " aria-current="page" to="/">
                    Home
                  </NavLink>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#">
                    Collection
                  </a>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/mint">
                    Mint
                  </NavLink>
                </li>
                {/* <li className="nav-item">
                  <NavLink className="nav-link" to="/mynfts">
                    My NFTs
                  </NavLink>
                </li> */}
              </ul>

              <div className="search-form">
                {WalletAddress.length > 0 ? (
                  <>
                    <button className="connect-wallet" onClick={showDropdown}>
                      {String(WalletAddress).substring(0, 6) +
                        "..." +
                        String(WalletAddress).substring(55)}
                    </button>

                    <ul id="connectwalletbtn" className="dopdod" onClick={disconnectAlgoWallet}>
                      <li>disconnect</li>
                    </ul>
                  </>
                ) : (
                  <button
                    className="connect-wallet"
                    onClick={connectAlgoWallet}
                  >
                    Connect Wallet
                  </button>
                )}
              </div>

            </div>
          </div>
        </nav>
      </section>
    </div>
  );
}

export default TopBar;
